import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const CheckIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M21.6272 4.66683C21.8112 4.46093 22.1273 4.44318 22.3332 4.62718C22.5162 4.79074 22.5506 5.05866 22.4267 5.26079L22.3728 5.33318L9.86184 19.3332C9.69226 19.5229 9.41211 19.5519 9.20915 19.4145L9.13702 19.3551L1.64801 11.9318C1.45189 11.7374 1.45049 11.4208 1.64489 11.2247C1.81769 11.0504 2.08703 11.0299 2.28249 11.164L2.35199 11.2216L9.467 18.273L21.6272 4.66683Z' />
    </svg>
  )
}
